import { instance } from '@/libs/api/instance'

/**
 * Get card and delivery price for a given card type / delivery type combo.
 * walletId must be the same wallet uuid used for GET /v1/card/info,
 * otherwise the price may be calculated for a different card provider
 * than the one the card type/design actually came from.
 *
 * @param {string} [walletId] - Card wallet UUID
 * @param card_type_id
 * @param delivery_type_id
 * @param currency_id
 */
export const getPriceInfo = (
  walletId,
  card_type_id,
  delivery_type_id,
  currency_id,
) => {
  return instance.get('/v1/card/info/price', {
    params: {
      walletId,
      card_type_id,
      delivery_type_id,
      currency_id,
    },
  })
}

/**
 * Order a new card
 *
 * @param walletDescription
 * @param walletColor
 * @param walletId
 * @param {string} [walletCurrencyId] - Currency for a newly created card wallet (used only when walletId is not set)
 * @param feeWalletId
 * @param type
 * @param firstName
 * @param lastName
 * @param street
 * @param house
 * @param {string|null} [apartment] - Flat or office number
 * @param city
 * @param countryId
 * @param postalCode
 * @param phone
 * @param password
 * @param deliveryType
 * @param signToken
 * @param {boolean|number} validate
 *
 * @return {Promise<AxiosResponse<any>>}
 */
export const create = (
  {
    walletDescription,
    walletColor,
    walletId,
    walletCurrencyId,
    feeWalletId,
    type,
    firstName,
    lastName,
    street,
    house,
    apartment,
    city,
    countryId,
    postalCode,
    phone,
    password,
    deliveryType,
    signToken,
    phone3ds,
  },
  { validate },
) => {
  return instance.post(
    '/v2/card',
    {
      walletDescription,
      walletColor,
      walletId,
      walletCurrencyId,
      feeWalletId,
      type,
      firstName,
      lastName,
      street,
      house,
      apartment,
      city,
      countryId,
      postalCode,
      phone,
      password,
      deliveryType,
      signToken,
      phone3ds,
    },
    {
      params: {
        validate: Number(validate),
      },
    },
  )
}
